export default {
  data() {
    return {
      showMenu: false,
    };
  },
  computed: {
    mobileMainMenu() {
      return this.$store.getters.MOBILE_MAIN_MENU;
    },
    mobileAccountMenu() {
      return this.$store.getters.MOBILE_ACCOUNT_MENU;
    },
    mobileCommonFavoritesMenu() {
      return this.$store.getters.MOBILE_COMMON_FAVORITES_MENU;
    },
    favoritesLength() {
      let favorites = [];

      if (this.favorites && this.favorites.length > 0) {
        this.favorites.forEach((album) => {
          album.items.forEach((photo) => {
            favorites.push(photo);
          });
        });
      }

      return favorites.length;
    },
  },
  methods: {
    goTo(path) {
      if (this.$router.currentRoute.path !== path) {
        this.$router.push(path);
      }

      this.$store.dispatch('SET_MOBILE_MAIN_MENU', false);
    },
    isActiveRoute(path) {
      return this.currentRoutePath.replace(/\/$/, '') === path;
    },
  },
};
